import type { ClientItemId } from "owa-client-ids";
import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { getItem } from "owa-mail-ribbon-utils/lib/getItem";
import { getSingleSelectedItemFromView } from "owa-mail-ribbon-command-actions/lib/getSelectedItemFromView";
import getSelectedTableView from "owa-mail-list-store/lib/utils/getSelectedTableView";
import shouldDisableAddinsForDecryption from "owa-mail-reading-pane-item-actions/lib/utils/shouldDisableAddinsForDecryption";

/**
 * Checks if addins should be disabled for decryption based on the addin-decryption feature flag
 * @param itemId - The item ID if in a popout context, undefined otherwise
 * @param mailboxInfo - The mailbox info to check the feature flag against
 * @returns true if addins should be disabled for decryption, false otherwise
 */
export function getIsDisabledForDecryption(itemId: ClientItemId | undefined, mailboxInfo: MailboxInfo): boolean {
    if (!isAccountFeatureEnabled("addin-decryption", mailboxInfo)) {
        return false;
    }
    
    // Get the item - from itemId for popouts, or from selected table view for main window
    const item = itemId ? getItem(itemId) : getSingleSelectedItemFromView(getSelectedTableView());
    
    return item ? shouldDisableAddinsForDecryption(item) : false;
}
